import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, HeartIcon } from 'lucide-react';
import type { SlideProps } from './SlideShell';
import { jascaydPilotMonths, jascaydPilotValue } from '../../data/jascaydOffer';
interface FloatingHeart {
  left: number;
  size: number;
  delay: number;
  duration: number;
  drift: number;
  opacity: number;
  filled: boolean;
}
const HEARTS: FloatingHeart[] = [{
  left: 6,
  size: 46,
  delay: 0,
  duration: 13,
  drift: 26,
  opacity: 0.9,
  filled: true
}, {
  left: 14,
  size: 26,
  delay: 3.4,
  duration: 15,
  drift: -18,
  opacity: 0.55,
  filled: false
}, {
  left: 22,
  size: 34,
  delay: 1.6,
  duration: 11.5,
  drift: 20,
  opacity: 0.75,
  filled: true
}, {
  left: 31,
  size: 22,
  delay: 5.2,
  duration: 14,
  drift: -24,
  opacity: 0.5,
  filled: false
}, {
  left: 39,
  size: 40,
  delay: 2.4,
  duration: 16,
  drift: 14,
  opacity: 0.35,
  filled: true
}, {
  left: 48,
  size: 24,
  delay: 6.4,
  duration: 12.5,
  drift: -12,
  opacity: 0.6,
  filled: false
}, {
  left: 57,
  size: 32,
  delay: 0.8,
  duration: 15.5,
  drift: 22,
  opacity: 0.45,
  filled: true
}, {
  left: 66,
  size: 20,
  delay: 4.2,
  duration: 12,
  drift: -20,
  opacity: 0.65,
  filled: false
}, {
  left: 74,
  size: 44,
  delay: 2.8,
  duration: 14.5,
  drift: 18,
  opacity: 0.85,
  filled: true
}, {
  left: 83,
  size: 28,
  delay: 6.8,
  duration: 13,
  drift: -16,
  opacity: 0.5,
  filled: false
}, {
  left: 91,
  size: 36,
  delay: 1.2,
  duration: 16.5,
  drift: 24,
  opacity: 0.7,
  filled: true
}, {
  left: 97,
  size: 22,
  delay: 4.8,
  duration: 12.8,
  drift: -14,
  opacity: 0.45,
  filled: false
}];
export function SlideLoveCover({}: SlideProps) {
  return <div className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-[var(--surface)] px-[clamp(2rem,7vw,7rem)] text-center" data-id="element-334" data-mp="18a19joybecg6">
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute left-0 top-0 h-2 w-full origin-left bg-[var(--brand)]" data-id="element-335" data-mp="13i9ti8csbp4a" />

      {/* Balloon hearts rising */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-336" data-mp="10hzvknrfwv8u">
        {HEARTS.map(heart => <motion.div key={`${heart.left}-${heart.delay}`} className="absolute bottom-[-8%]" style={{
        left: `${heart.left}%`
      }} initial={{
        y: 0,
        x: 0,
        opacity: 0
      }} animate={{
        y: ['0%', '-125vh'],
        x: [0, heart.drift, -heart.drift * 0.6, 0],
        opacity: [0, heart.opacity, heart.opacity, 0]
      }} transition={{
        duration: heart.duration,
        delay: heart.delay,
        repeat: Infinity,
        ease: 'linear',
        times: [0, 0.12, 0.82, 1]
      }} data-id="element-337" data-mp="14jbl6tabdgh1">
            <motion.div animate={{
          scale: [1, 1.14, 1],
          rotate: [-6, 6, -6]
        }} transition={{
          duration: 2.6,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: heart.delay * 0.4
        }} data-id="element-338" data-mp="vhln54lxfjaa">
              <HeartIcon className={heart.filled ? 'text-[var(--brand)] fill-current' : 'text-[var(--brand)]'} style={{
            width: heart.size,
            height: heart.size
          }} strokeWidth={heart.filled ? 0 : 2.4} data-id="element-339" data-mp="3rj08qsi9hjeq" />
            </motion.div>
          </motion.div>)}
      </div>

      <div className="relative flex max-w-6xl flex-col items-center" data-id="element-340" data-mp="38objrfawnjl7">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        duration: 0.5
      }} className="mb-[clamp(1.25rem,2.5vw,2.25rem)] inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 rounded-full bg-white px-[clamp(1rem,1.8vw,1.6rem)] py-[clamp(0.45rem,0.8vw,0.7rem)] text-[clamp(0.75rem,1.15vw,1.05rem)] font-bold uppercase tracking-[0.18em] text-[var(--fg)] shadow-sm ring-1 ring-[var(--brand)]/15" data-id="element-341" data-mp="33q9xkli6n45i">
          <span className="text-[var(--brand)]" data-id="element-342" data-mp="103hw10142fls">Campaign proposal</span>
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]/40" aria-hidden="true" data-id="element-343" data-mp="150i57jt9byh4" />
          <span data-id="element-344" data-mp="q3irrfbq5beq">Jascayd</span>
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]/40" aria-hidden="true" data-id="element-345" data-mp="q4ao4sd5bd62" />
          <span className="text-[var(--muted)]" data-id="element-346" data-mp="v1smjotje9zt">Boehringer Ingelheim</span>
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.75,
        ease: 'easeOut'
      }} className="text-[clamp(3rem,9vw,9rem)] font-extrabold leading-[0.92] tracking-[-0.055em] text-[var(--fg)]" data-id="element-347" data-mp="hanqewpdnzu8">
          All you need is love.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.65,
        duration: 0.55
      }} className="mt-[clamp(1.25rem,2.4vw,2rem)] text-[clamp(0.95rem,1.5vw,1.5rem)] font-semibold tracking-[-0.01em] text-[var(--muted)]" data-id="element-348" data-mp="3ui8rn5g6omti">
          Attention makes things thrive.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.85,
        duration: 0.55
      }} className="mt-[clamp(1rem,2vw,1.75rem)] flex flex-wrap items-center justify-center gap-x-[clamp(0.75rem,1.6vw,1.5rem)] gap-y-2" data-id="element-349" data-mp="3azbj87ybvcoe">
          {['Short.', 'Sharp.', 'Satisfying.'].map((word, index) => <span key={word} className="flex items-center gap-[clamp(0.75rem,1.6vw,1.5rem)]" data-id="element-350" data-mp="3tvktek63zj34" data-mpi={index}>
              {index > 0 && <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand)]/40" aria-hidden="true" data-id="element-351" data-mp="7hb7chpnin5i" />}
              <span className="text-[clamp(1rem,1.9vw,1.85rem)] font-extrabold tracking-[-0.03em] text-[var(--brand)]" data-id="element-352" data-mp="ggy7l06n9mwz">
                {word}
              </span>
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.25,
        duration: 0.6
      }} className="mt-[clamp(1rem,2.2vw,1.9rem)] flex max-w-4xl flex-col items-center rounded-2xl bg-white px-[clamp(1.1rem,2.4vw,2.2rem)] py-[clamp(0.85rem,1.6vw,1.4rem)] shadow-sm ring-1 ring-[var(--brand)]/15" data-id="element-353" data-mp="3ea01gdpc75ne">
          <p className="text-[clamp(0.85rem,1.3vw,1.2rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-354" data-mp="1t36ngslw678">
            A {jascaydPilotMonths}-month pilot gives the Jascayd team a fast,
            low-risk way to reach pulmonologists and rheumatologists — and
            real data on what works before scaling across the region.
          </p>
          <ul className="mt-[clamp(0.6rem,1.1vw,0.9rem)] flex flex-wrap items-center justify-center gap-[clamp(0.4rem,0.8vw,0.65rem)]" data-id="element-355" data-mp="27ncujxo10c7r">
            {jascaydPilotValue.map(value => <li key={value} className="inline-flex items-center gap-1.5 rounded-full bg-[var(--surface)] px-[clamp(0.7rem,1.1vw,1rem)] py-[clamp(0.3rem,0.55vw,0.45rem)] text-[clamp(0.75rem,1.05vw,0.98rem)] font-bold text-[var(--brand)]" data-id="element-356" data-mp="252omy8af7599">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-357" data-mp="1qd8vsr6z8xt1" />
                {value}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </div>;
}